import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function UnlockWebsite({ setIt }) {
    const { t, i18n } = useTranslation("unlockWeb");

    useEffect(() => {
        if (window.location.hostname.includes("kechain")) {
            window.location.href = "https://www.projectpsk.cz?lang=en";
        }
    }, []);

    useEffect(() => {
        const checkLanguage = async () => {
            const searchParams = new URLSearchParams(window.location.search);
            const langParam = searchParams.get("lang");

            if (langParam === "en") {
                await i18n.changeLanguage("en-EN");
            }
        };

        checkLanguage();
    }, [i18n]);

    const [password] = useState(532506027);
    const history = useHistory();

    const checkPass = (pass) => {
        let hash = 0, i, chr;
        if (pass.length === 0) return hash;
        for (i = 0; i < pass.length; i++) {
            chr = pass.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        if (hash === password) {
            let date = new Date();
            let expires = 'expires=';
            date.setDate(date.getDate() + 1);
            expires += date.toUTCString();
            document.cookie = "UNLOCKED=yes; " + expires + ";";
            setIt(true);
            history.push("/");
        }

        return false;
    }

    const handleLanguageChange = (e) => {
        const selectedValue = e.target.value;
        i18n.changeLanguage(selectedValue);
    };
    console.log("XDD");
    return (
        <div className="unlockWeb">
            <div className="unlockWeb-container flex flex-col justify-center items-center w-full h-screen">
                <p className={"w-fit text-2xl bold"}>{t('title')}</p>
                <input type="password" className="w-96 py-1 px-0.5 rounded border-2 border-dark-green" onChange={(e) => checkPass(e.target.value)} />
                <select onChange={handleLanguageChange} className="mt-8 px-4" defaultValue={i18n.language}>
                    <option value="en">EN</option>
                    <option value="cs">CS</option>
                    <option value="de">DE</option>
                    <option value="es">ES</option>
                    <option value="hu">HU</option>
                    <option value="ro">RO</option>
                    <option value="ru">RU</option>
                    <option value="sk">SK</option>
                </select>
            </div>
        </div>
    );
}
